import api from '../lib/api'

export const registerPushToken = (tenantId, token) =>
  api.post(`/manager/push/${tenantId}/register`, { token }).then(r => r.data)

export const unregisterPushToken = (tenantId, token) =>
  api.delete(`/manager/push/${tenantId}/unregister`, { data: { token } }).then(r => r.data)
